import { SET_SUMMARY_FILTER, SET_SUMMARY_STORE_TYPE } from 'revenue/constants'
import { buildAction } from 'store/actions/actionCreator'

import { FETCH_COMPLETENESS_GENERAL_REVENUE, FETCH_COUNTRIES, FETCH_DELAYED_STORES } from './constants'

export const fetchCountries = buildAction(FETCH_COUNTRIES, 'dateCurrent', 'range')
export const fetchCompletenessGeneralRevenue = buildAction(FETCH_COMPLETENESS_GENERAL_REVENUE)
export const fetchDelayedStores = buildAction(FETCH_DELAYED_STORES)
export const setSummaryStoreType = buildAction(SET_SUMMARY_STORE_TYPE, 'summaryStoreType')
export const setSummaryFilter = buildAction(SET_SUMMARY_FILTER, 'summaryFilter')
